import contentTagsService from 'common/content-tags-service'

import types from './types'

const fetchContentTags = () => {
  return (dispatch) => {
    dispatch({ type: types.FETCH_CONTENT_TAGS_START })
    return contentTagsService
      .getContentTags()
      .then((contentTags) => {
        dispatch({
          type: types.FETCH_CONTENT_TAGS_SUCCESS,
          payload: contentTags,
        })
      })
      .catch(() => dispatch({ type: types.FETCH_CONTENT_TAGS_FAILURE }))
  }
}

export default {
  fetchContentTags,
}
